import COSInvoiceContainer from "./COSInvoice.container";

export default COSInvoiceContainer;
